export default __webpack_public_path__ + "static/media/beEco.10f9dd0f.png";